export default "__VITE_ASSET__BtP4xRfe__"